import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtosiddhatekdarshanbus() {



  const cardData =
  {
    keyword: 'Daund to Siddhatek Darshan Bus On Rent',
    heading: 'Sanavi Travels: Daund to Siddhatek Darshan Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund to Siddhatek Darshan Bus On Rent, providing safe, comfortable, and convenient transportation for pilgrims, families, groups, and corporate travelers visiting the holy Siddhatek temple. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for religious trips, group travel, family outings, and corporate tours. Choose Sanavi Travels for trusted Daund to Siddhatek Darshan bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Siddhatek with Sanavi Travels',


"topPlaces": [
  {
    "title": "Siddhatek Ganpati Temple",
    "description": "Siddhatek Ganpati Temple is a revered Ashtavinayak shrine dedicated to Lord Ganesha. Situated on the banks of the Bhima River, it is believed to be a place where devotees receive special blessings for overcoming obstacles and gaining wisdom."
  },
  {
    "title": "Temple Courtyard and Steps",
    "description": "The temple features a spacious courtyard and stone steps leading up to the sanctum. Pilgrims often climb the steps as part of their devotion, enjoying the peaceful surroundings and spiritual ambiance."
  },
  {
    "title": "Bhima River View",
    "description": "The temple is located near the Bhima River, providing a serene riverside setting. Devotees can enjoy calm reflections, ritual baths, and the natural beauty of the flowing waters."
  },
  {
    "title": "Temple Gardens",
    "description": "The gardens surrounding Siddhatek Temple offer tranquil spots for meditation, relaxation, and quiet contemplation amidst greenery and sacred architecture."
  },
  {
    "title": "Local Markets and Shops",
    "description": "Small markets near the temple sell religious items, souvenirs, prasads, and traditional handicrafts, providing visitors a chance to take home spiritual mementos."
  },
  {
    "title": "Ashtavinayak Pilgrimage Stop",
    "description": "Siddhatek is an important stop on the Ashtavinayak pilgrimage route. Devotees visit this temple after Morgaon and before other Ashtavinayak shrines, making it a central part of the spiritual journey."
  },
  {
    "title": "Devotee Accommodation Facilities",
    "description": "Dharmashalas and lodging facilities near the temple offer pilgrims comfortable stays for overnight visits and participation in temple rituals."
  },
  {
    "title": "Festivals and Celebrations",
    "description": "Ganesh Chaturthi and other festivals are celebrated at Siddhatek with processions, music, and traditional ceremonies, attracting large numbers of devotees."
  },
  {
    "title": "Scenic Hills Surrounding the Temple",
    "description": "The temple is set against scenic hills, providing trekking opportunities and panoramic views that enhance the spiritual experience for visitors."
  },
  {
    "title": "Religious Learning Centers",
    "description": "The temple complex includes areas for devotees to learn about Lord Ganesha, Ashtavinayak traditions, and participate in spiritual discourses by priests and scholars."
  }
]
,



"services": [
    {
      "name": "Daund to Siddhatek Darshan Bus On Rent",
      "description": "Daund to Siddhatek Darshan Bus On Rent provides comfortable and reliable bus services for devotees and travelers visiting Siddhatek Ganpati temple. Spacious buses and professional drivers ensure a smooth and safe journey."
    },
    {
      "name": "Siddhatek Ganpati Bus",
      "description": "Siddhatek Ganpati Bus specializes in transporting pilgrims to the Siddhatek temple. With organized itineraries, timely service, and well-maintained buses, it offers a convenient and stress-free religious travel experience."
    },
    {
      "name": "AC Bus Daund to Siddhatek",
      "description": "AC Bus Daund to Siddhatek provides air-conditioned buses for comfortable long-distance travel. Ideal for family trips, group tours, and religious pilgrimages, ensuring a pleasant and refreshing journey."
    },
    {
      "name": "Religious Tour Bus Daund",
      "description": "Religious Tour Bus Daund caters to devotees traveling to Siddhatek and other nearby temples. Reliable buses, experienced drivers, and organized itineraries make pilgrimages safe and hassle-free."
    },
    {
      "name": "Family Bus Siddhatek",
      "description": "Family Bus Siddhatek is designed for family travel, providing spacious seating, safety features, and comfort for all members, making trips to the temple enjoyable and convenient."
    },
    {
      "name": "Group Travel Bus Siddhatek",
      "description": "Group Travel Bus Siddhatek offers organized transportation for groups of friends, corporate teams, and devotees. Comfortable seating, professional drivers, and timely service ensure a smooth group journey."
    },
    {
      "name": "Affordable Bus Siddhatek",
      "description": "Affordable Bus Siddhatek provides budget-friendly travel options without compromising on comfort or safety. Perfect for families, groups, and individual travelers seeking reliable transport from Daund to Siddhatek."
    },
    {
      "name": "Chauffeur Driven Bus Siddhatek",
      "description": "Chauffeur Driven Bus Siddhatek ensures a stress-free travel experience with professional drivers managing navigation, traffic, and schedules. Perfect for family trips, religious tours, and group travel."
    },
    {
      "name": "Best Bus Daund to Siddhatek",
      "description": "Best Bus Daund to Siddhatek guarantees high-quality buses, punctual service, and professional drivers. Suitable for religious trips, family outings, and group excursions, ensuring a reliable and comfortable journey."
    },
    {
      "name": "Tourist Bus Siddhatek",
      "description": "Tourist Bus Siddhatek caters to travelers exploring Siddhatek and nearby attractions. Spacious buses, flexible itineraries, and experienced drivers provide a memorable and convenient travel experience."
    },
    {
      "name": "Online Bus Booking Daund",
      "description": "Online Bus Booking Daund allows travelers to reserve Siddhatek buses quickly and easily. Instant confirmation, multiple bus options, and flexible scheduling simplify travel planning for families and groups."
    },
    {
      "name": "Temple Darshan Bus",
      "description": "Temple Darshan Bus provides organized transport for visiting Siddhatek and other temples. Safe, comfortable, and well-maintained buses with professional drivers make religious trips seamless and enjoyable."
    },
    {
      "name": "One Day Trip Bus",
      "description": "One Day Trip Bus offers convenient transportation for a day visit from Daund to Siddhatek. Ideal for devotees and tourists seeking a hassle-free short trip with reliable travel arrangements."
    },
    {
      "name": "Daund Travel Bus",
      "description": "Daund Travel Bus provides comprehensive travel solutions for trips from Daund to Siddhatek. Combining comfort, safety, and affordability, it caters to families, groups, and tourist travelers."
    },
    {
      "name": "Ashtavinayak Bus Tour",
      "description": "Ashtavinayak Bus Tour includes Siddhatek as a key destination. Perfect for devotees undertaking the Ashtavinayak pilgrimage, offering well-planned itineraries, comfortable buses, and professional drivers for a memorable journey."
    }
  ],
  "tableData": [
    ["Daund to Siddhatek Darshan Bus On Rent", "Siddhatek Ganpati Bus"],
    ["AC Bus Daund to Siddhatek", "Religious Tour Bus Daund"],
    ["Family Bus Siddhatek", "Group Travel Bus Siddhatek"],
    ["Affordable Bus Siddhatek", "Chauffeur Driven Bus Siddhatek"],
    ["Best Bus Daund to Siddhatek", "Tourist Bus Siddhatek"],
    ["Online Bus Booking Daund", "Temple Darshan Bus"],
    ["One Day Trip Bus", "Daund Travel Bus"],
    ["Ashtavinayak Bus Tour", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund to Siddhatek Darshan Bus on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Daund to Siddhatek for pilgrimage tours, ideal for large groups, family trips, and religious excursions."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced, ensuring a smooth and comfortable journey from Daund to Siddhatek."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with the Daund to Siddhatek route, ensuring safe, timely, and smooth travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Daund to Siddhatek bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Daund to Siddhatek pilgrimage trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group's schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Siddhatek bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Daund to Siddhatek?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services for pilgrimage trips from Daund to Siddhatek.'
  },
  {
    question: 'How can I book a bus from Daund to Siddhatek?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rental from Daund to Siddhatek?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options for your pilgrimage trip.'
  },
  {
    question: 'Are the drivers experienced with the Daund to Siddhatek route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Siddhatek route, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off in Siddhatek.'
  },
  {
    question: 'Is the bus service from Daund to Siddhatek available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus services from Daund to Siddhatek to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience for your group.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Siddhatek bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikas Deshmukh',
    feedback: 'Rented a bus for our pilgrimage trip from Daund to Siddhatek. Comfortable journey, professional driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Jyoti Shinde',
    feedback: 'Sanavi Travels made our Daund to Siddhatek journey smooth and hassle-free. Highly recommend their bus rental service for pilgrimage.',
    rating: 5
  }
];





































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Siddhatek Darshan Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels offers AC and chauffeur-driven buses from Daund to Siddhatek for Ganpati Darshan, family trips, and Ashtavinayak religious tours. Affordable, reliable, and easy online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "42"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Daund to Siddhatek Darshan Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC and chauffeur-driven buses from Daund to Siddhatek for Ganpati Darshan, family trips, and Ashtavinayak religious tours. Affordable, reliable, and easy online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/124.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtosiddhatekdarshanbus;